import { useLingui } from '@lingui/react'
import type { FC } from 'react'

import CostDetails from 'views/components/organisms/CartSumBox/CostDetails'
import { CREDIT_BALANCE_INFORMATION_MODAL } from 'views/components/organisms/CreditBalanceInformationModal/names'

type Props = {
  applicableCredit?: number
  isVoucherOrRedPoints?: boolean
}

const CreditBalanceCostDetails: FC<Props> = ({
  applicableCredit,
  isVoucherOrRedPoints,
}) => {
  const { i18n } = useLingui()
  if (!applicableCredit) {
    return null
  }

  const costDetailsProps = {
    key: 'creditBalance',
    label: i18n._('general.cartSumBox.credit.balance.applicable'),
    value: applicableCredit * -1,
    modal: CREDIT_BALANCE_INFORMATION_MODAL,
    purpose: 'creditBalance',
    infoIconDataQaId: 'credit-balance-information-info-icon',
  }

  if (isVoucherOrRedPoints) {
    return (
      <>
        <hr className="u-margin-large--bottom u-margin-large--top o-CartSumBox__slimBorder" />
        <CostDetails {...costDetailsProps} />
      </>
    )
  }

  return <CostDetails {...costDetailsProps} />
}

export default CreditBalanceCostDetails
